'use strict';

/**
 * パラメータ取得
 * @param name
 * @param url
 * @returns {*}
 */
function getParam(name, url){
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  let results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// device
export const deviceName  = (state)=>state.device.deviceName;
export const browserName = (state)=>state.device.browserName;
export const osName      = (state)=>state.device.osName;
export const mode        = (state)=>{
  return state.device.mode || getParam('type');
};
export const token        = (state)=>{
  return state.device.token || getParam('token');
};

// auth
export const cognitoIdentityId = (state)=>state.auth.cognitoIdentityId;

// d3
export const imageName                         = (state)=>state.d3.imageName;
export const isUploadingImage                  = (state)=>state.d3.isUploadingImage;
export const imageUploadingProgressPercent     = (state)=>state.d3.imageUploadingProgressPercent;
export const scannedDiscData                   = (state)=>state.d3.scannedDiscData;
export const scanError                         = (state)=>state.d3.scanError;
export const discData                          = (state)=>state.d3.discData;
export const isSubmittingInquiry               = (state)=>state.d3.isSubmittingInquiry;
export const hasSignedCookie                   = (state)=>state.d3.hasSignedCookie;
export const contentsListScrollPosition        = (state)=>state.d3.contentsListScrollPosition;
export const isFinishQuestionnaire             = (state)=>state.d3.isFinishQuestionnaire;
export const isFinishInputInfoDocumentDownload = (state)=>state.d3.isFinishInputInfoDocumentDownload;

// router
export const routerHash = (state)=>state.route.hash;



// WEBPACK FOOTER //
// ./src/store/getters.js